import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import * as Models from '../../../../../../src/app/models/commonModels';
import { AldFormBaseComponent } from '../../../../../../src/app/shared/components/form/ald-form.component';
import { AuthenticationService } from '../../../../../../src/app/shared/services/authentication.service';
import { EnvironmentService } from '../../../../../../src/app/services/environment.service';
import { HelperService } from "../../../../../../src/app/services/helper/helper.service";

import { SettingsState } from '../../../../../../src/app/services/settings/settings.state';
import * as SettingsAction from '../../../../../../src/app/services/settings/settings.action';

import { User } from '../../../../../../src/app/models/user/user';

import { SettingsPreview } from '../../../../../../src/app/models/settings/settings';

import * as CarModels from "../../../../../../src/app/models/car/car";
import * as GarageVisitsModels from '../../../../../../src/app/models/garage-visits/garage-visits';
import { AldState } from "../../../../../../src/app/services/ald/ald.state";
import * as AldActions from "../../../../../../src/app/services/ald/ald.action";


@Component({
    selector: 'app-garage-visits',
  templateUrl: './garage-visits.component.html',
  styleUrls: ['./garage-visits.component.css']
})

export class GarageVisitsComponent extends AldFormBaseComponent implements OnInit {


  public requestGet: Models.RequestModel = null;

  public garageVisits: GarageVisitsModels.GarageVisitModel[];


  @Select(AldState.MainVisits)
  MainVisits$: Observable<Models.ResponseList<GarageVisitsModels.GarageVisitModel>>;


    constructor(
        private formBuilder: FormBuilder,
        public router: Router,
        public authenticationService: AuthenticationService,
        public store: Store,
        public helperService: HelperService,
        public environmentService: EnvironmentService,
        public changeDetectorRef: ChangeDetectorRef
    ) {

      super(helperService, environmentService, changeDetectorRef, router, authenticationService,store);
    }

  ngOnInit() {

    super.ngOnInit();

    this.subscription.add(this.MainVisits$.subscribe((data) => {
      if (data && data.Success) {
        this.garageVisits = data.Items;
        }
      }));
    }


  public onUserAuthenitcate() {

    if (this.currentUser && this.currentUser.CarId) {

      this.requestGet = new Models.RequestModel(this.currentUser.CarId);

      this.store.dispatch(new AldActions.VisitsGet(this.requestGet));
    }
  };

  public onSummary() { }
}
